export { default } from "./FormPage";